import React from 'react';
import { useQuery } from '@apollo/client';

import { QUERY } from '../../gql-operations';
import PublishedFolderPage from './PublishedFolderPage';
import PublishedMessagePage from './PublishedMessagePage';
import PublishedShareCollectionPage from './PublishedShareCollectionPage';
import {GET_PUBLISHED_SHARE_COLLECTION} from '../../gql-operations/queries/sharing/share-collections';

/**
 * A /s/:token link is opaque — nothing in the URL says whether it points at a
 * published folder or a published message (see PublishedResource.token in
 * server/src/modules/db/models/publishedResource.ts). Try the folder query
 * first (the more common case per docs/SHARING_AND_PUBLISHING_PLAN.md's
 * Product Goal examples); on PUBLISHED_LINK_NOT_FOUND, fall back to the
 * message page, which runs its own query. This costs one extra failed
 * request for message links — acceptable for V1, revisit if that traffic
 * share turns out to matter (e.g. by encoding a type discriminator in the
 * token or URL if this becomes a real cost).
 */
const PublishedLinkRouter = props => {
    const token = props.match.params.token;

    const { data, loading, error } = useQuery(QUERY.GET_PUBLISHED_FOLDER, {
        variables: { data: { token } },
        skip: !token,
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
    });

    if (loading) {
        return null;
    }

    const isNotFound = error?.graphQLErrors?.some(
        graphQLError => graphQLError.extensions?.code === 'PUBLISHED_LINK_NOT_FOUND'
    );

    if (data?.getPublishedFolder && !error) {
        return <PublishedFolderPage {...props} />;
    }

    if (isNotFound || error) {
        return <PublishedMessagePage {...props} />;
    }

    return <PublishedFolderPage {...props} />;
};

function CollectionAwarePublishedLinkRouter(props) {
    const token=props.match.params.token;
    const query=useQuery(GET_PUBLISHED_SHARE_COLLECTION,{variables:{token},skip:!token,fetchPolicy:'network-only'});
    if(query.loading)return null;
    if(query.data?.getPublishedShareCollection&&!query.error)return <PublishedShareCollectionPage key={token} token={token}/>;
    return <PublishedLinkRouter {...props}/>;
}
export default CollectionAwarePublishedLinkRouter;
